/*
 * Copyright (C) 2025 SimpliCity Digital Inc - All Rights Reserved
 */

import { Link } from "react-router-dom";
import { ReactComponent as Logo } from "cms/assets/images/nsbylaw-logo.svg";

const HeaderLogo = () => {
    return (
        <Link to='/' className='header-logo'>
            <Logo className="header-logo-image" />
            <div className="header-logo-text">North Shore<br />Dispute Registry</div>
        </Link>
    );
};

export { HeaderLogo };
